import React, {Component} from 'react';
import {connect} from 'react-redux';

import getAxiosInstance, {BASE_URL_TYPE} from '../../api/axios';
import * as actionCreators from '../../store/actions/index';
import PopupBase from './PopupBase';
import Radio from './FormElements/Radio';

const axios = getAxiosInstance();
const propTypes = {};

class FeedbackPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      submitted: false,
    };

    // Class properties.
    this.ref = React.createRef();
    this.form = React.createRef();

    // Binding handlers.
    this.close = this.close.bind(this);
    this.save = this.save.bind(this);
  }

  close(e) {
    e.preventDefault();
    this.ref.current.close();
  }

  save(e) {
    e.persist();
    e.preventDefault();
    const {current: formValues} = this.form;
    const data = {
      webform_id: 'feedback',
      answer: formValues.answer.value,
      message: formValues.message.value,
    };
    axios.post(`${BASE_URL_TYPE.PROPZONE}/webform_rest/submit`, data).then((result) => {
      if (result.data && result.data.sid) {
        this.setState({submitted: true});
      }
    });
  }

  render() {
    const {submitted} = this.state;
    let popupContent = <div>Thanks for your feedback!</div>;
    if (!submitted) {
      popupContent = (
        <form ref={this.form} onSubmit={this.save}>
          <h3>{this.subject}</h3>
          <label htmlFor="name" className="for-text">
            Did you achive your goal?
          </label>
          <div className="flexbox-container radios">
            <Radio label="Yes" name="answer" value="yes" checked />
            <Radio label="Partially" name="answer" value="partially" />
            <Radio label="No" name="answer" value="no" />
          </div>
          <div className="form-element textarea">
            <label htmlFor="message" className="for-text">
              Tell us more about your experience so we can keep improving our product.
            </label>
            <textarea placeholder="Write your feedback here…" id="message" name="message" />
          </div>
          <div className="powered-logo">
            <img
              alt="Powered by Gridics"
              src={`${BASE_URL_TYPE.PROPZONE}/themes/custom/gridics/images/logo-full.svg`}
            />
          </div>
          <div className="buttons">
            <input type="submit" className="btn" value="Submit" />
          </div>
        </form>
      );
    }
    return (
      <PopupBase ref={this.ref} title="Send Us Your Feedback!" className="feedback-popup">
        {popupContent}
      </PopupBase>
    );
  }
}

FeedbackPopup.propTypes = propTypes;

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  setLoading: state => dispatch(actionCreators.setLoading(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackPopup);
